const EYEBROW =
  'font-mono text-tiny font-medium uppercase tracking-eyebrow-wide text-faint-foreground';

export function DrawerSection({
  title,
  children,
}: Readonly<{ title: string; children: React.ReactNode }>): React.JSX.Element {
  return (
    <section className="flex flex-col gap-2">
      <span className={EYEBROW}>{title}</span>
      {children}
    </section>
  );
}
